import React from "react";
import { Languages, Download } from "lucide-react";

const PAID = new Set(["paid", "confirmed", "completed"]);
const LANGS = [
  { key: "italian", label: "Italian" },
  { key: "english", label: "English" },
  { key: "both", label: "Both languages" },
];

const peopleIn = (att, isMatrix) =>
  (isMatrix ? (att.section_1_tickets || 0) + (att.section_2_tickets || 0) : (att.member_tickets || 0) + (att.family_tickets || 0)) +
  (att.minor_count || 0) + (att.guest_count || 0);

/** Event Financials: paid attendees per guided-visit language, to plan the guides. */
export const GuidedLanguageSummary = ({ attendees = [], isMatrix = false, onDownload }) => {
  const withLang = attendees.filter((a) => a.guided_language);
  if (withLang.length === 0) return null;

  const counts = { italian: { b: 0, p: 0 }, english: { b: 0, p: 0 }, both: { b: 0, p: 0 } };
  let pending = 0;
  withLang.forEach((a) => {
    const c = counts[a.guided_language];
    if (!c) return;
    if (PAID.has(String(a.payment_status).toLowerCase())) {
      c.b += 1;
      c.p += peopleIn(a, isMatrix);
    } else {
      pending += 1;
    }
  });

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="guided-language-summary">
      <div className="flex items-center gap-2 mb-3">
        <Languages className="h-4 w-4 text-emerald-700" />
        <h3 className="text-sm font-semibold text-slate-900">Guided visit languages (paid)</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {LANGS.map(({ key, label }) => (
          <div key={key} className="rounded-md border border-slate-200 bg-slate-50 p-3" data-testid={`guided-language-count-${key}`}>
            <p className="text-xs text-slate-600">{label}</p>
            <p className="text-lg font-bold text-slate-900">
              {counts[key].p} <span className="text-sm font-normal text-slate-500">people</span>
            </p>
            <p className="text-xs text-slate-500">{counts[key].b} booking{counts[key].b !== 1 ? "s" : ""}</p>
            {onDownload && counts[key].b > 0 && (
              <button
                type="button"
                onClick={() => onDownload(key)}
                className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-emerald-700 hover:text-emerald-900 hover:underline"
                data-testid={`guide-list-download-${key}`}
              >
                <Download className="h-3.5 w-3.5" /> Guide list (Excel)
              </button>
            )}
          </div>
        ))}
      </div>
      {pending > 0 && (
        <p className="text-xs text-slate-500 mt-2" data-testid="guided-language-pending">
          {pending} unpaid booking{pending !== 1 ? "s" : ""} not counted.
        </p>
      )}
    </div>
  );
};
